import Sap from "../components/Sap";
import Powerbi from "../components/Powerbi";
import Webdesign from "../components/Webdesign";
import Caddesign from "../components/Caddesign";
import Solidworks from "../components/Solidworks";
import Catia from "../components/Catia";
import Rhinocer from "../components/Rhinocer";
import Autodesk from "../components/Autodesk";
import Etbs from "../components/Etbs";
import Staad from "../components/Staad";
import Finalcutpro from "../components/Finalcutpro";
import Cinema from "../components/Cinema";
import Autodeskmaya from "../components/Autodeskmaya";
import Animaker from "../components/Animaker";
import Gimp from "../components/Gimp";
import { useParams } from "react-router-dom";

const ServicePages = () => {
    const { id } = useParams();
    console.log(id);

    return (
        <div>
            {id === "sap" && <Sap />}
            {id === "powerbi" && <Powerbi />}
            {id === "webdesign" && <Webdesign />}
            {id === "caddesign" && <Caddesign />}
            {id === "solidworks" && <Solidworks />}
            {id === "catia" && <Catia />}
            {id === "rhinocer" && <Rhinocer />}
            {id === "autodesk" && <Autodesk />}
            {id === "etbs" && <Etbs />}
            {id === "staad" && <Staad />}
            {id === "finalcutpro" && <Finalcutpro />}
            {id === "cinema" && <Cinema />}
            {id === "autodeskmaya" && <Autodeskmaya />}
            {id === "animaker" && <Animaker />}
            {id === "gimp" && <Gimp />}
        </div>
    );
};

export default ServicePages;
